import styles from "./TagsList.module.scss";

type Props = {
  tagIds: number[] | null | undefined;
  availableTags?: Map<number, string>;
  questionId: string;
  startTrimmingTagsAfter: number;
};

export function TagsList(props: Props) {
  if (!props.tagIds?.length) {
    return null;
  }

  if (props.tagIds.length > props.startTrimmingTagsAfter) {
    const tagParens = new RegExp(/\(([A-Z]*)\)/);
    return (
      <div className={styles.tagsListContainer}>
        {props.tagIds?.map((t) => {
          const tag = props.availableTags?.get(t);
          const match = tag && tagParens.exec(tag);

          return (
            <span
              key={`${props.questionId}-tag-${t}`}
              className={styles.tagPill}
            >
              {match ? match[1] : tag}
            </span>
          );
        })}
      </div>
    );
  }

  return (
    <div className={styles.tagsListContainer}>
      {props.tagIds?.map((t) => {
        return (
          <span key={`${props.questionId}-tag-${t}`} className={styles.tagPill}>
            {props.availableTags?.get(t)}
          </span>
        );
      })}
    </div>
  );
}
